
import './modernizr.js'; // 'npm run modernizr' to create this file
import '../node_modules/jquery-slimscroll/jquery.slimscroll.js';




// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/vendor.ts